module.exports = "/assets/data/b5834c0cdf6e37efc30ff728432dea8a-SS0.data.json";